import { BaseFetch } from "../main-model"
export default class BehaviorModel extends BaseFetch {
    getBehaviorBy = (data) =>
    this.authFetch({
      url: "behavior/getBehaviorBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getBehaviorById = (data) =>
    this.authFetch({
      url: "behavior/getBehaviorById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertBehavior = (data) =>
    this.authFetch({
      url: "behavior/insertBehavior",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateBehaviorById = (data) =>
    this.authFetch({
      url: "behavior/updateBehaviorById",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteBehaviorById = (data) =>
    this.authFetch({
      url: "behavior/deleteBehaviorById",
      method: "POST",
      body: JSON.stringify(data),
    })
   
}
